/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as ProtectedRouteImport } from "./routes/_protected"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as DocsIndexRouteImport } from "./routes/docs/index"
import { Route as OauthConsentRouteImport } from "./routes/oauth/consent"
import { Route as DocsSplatRouteImport } from "./routes/docs/$"
import { Route as AuthVerifyEmailRouteImport } from "./routes/auth/verify-email"
import { Route as AuthSignupRouteImport } from "./routes/auth/signup"
import { Route as AuthResetPasswordRouteImport } from "./routes/auth/reset-password"
import { Route as AuthLoginRouteImport } from "./routes/auth/login"
import { Route as AuthForgotPasswordRouteImport } from "./routes/auth/forgot-password"
import { Route as AuthCallbackRouteImport } from "./routes/auth/callback"
import { Route as ProtectedDashboardRouteImport } from "./routes/_protected/dashboard"
import { Route as ProtectedChatRouteImport } from "./routes/_protected/chat"
import { Route as ProtectedSplatRouteImport } from "./routes/_protected/$"
import { Route as ProtectedDiscordSettingsRouteImport } from "./routes/_protected/discord/settings"
import { Route as ProtectedChatSessionIdRouteImport } from "./routes/_protected/chat_.$sessionId"

const ProtectedRoute = ProtectedRouteImport.update({
  id: "/_protected",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const DocsIndexRoute = DocsIndexRouteImport.update({
  id: "/docs/",
  path: "/docs/",
  getParentRoute: () => rootRouteImport,
} as any)
const OauthConsentRoute = OauthConsentRouteImport.update({
  id: "/oauth/consent",
  path: "/oauth/consent",
  getParentRoute: () => rootRouteImport,
} as any)
const DocsSplatRoute = DocsSplatRouteImport.update({
  id: "/docs/$",
  path: "/docs/$",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: "/auth/verify-email",
  path: "/auth/verify-email",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: "/auth/signup",
  path: "/auth/signup",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: "/auth/reset-password",
  path: "/auth/reset-password",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: "/auth/login",
  path: "/auth/login",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: "/auth/forgot-password",
  path: "/auth/forgot-password",
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: "/auth/callback",
  path: "/auth/callback",
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedDashboardRoute = ProtectedDashboardRouteImport.update({
  id: "/dashboard",
  path: "/dashboard",
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedChatRoute = ProtectedChatRouteImport.update({
  id: "/chat",
  path: "/chat",
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSplatRoute = ProtectedSplatRouteImport.update({
  id: "/$",
  path: "/$",
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedDiscordSettingsRoute =
  ProtectedDiscordSettingsRouteImport.update({
    id: "/discord/settings",
    path: "/discord/settings",
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedChatSessionIdRoute = ProtectedChatSessionIdRouteImport.update({
  id: "/chat_/$sessionId",
  path: "/chat/$sessionId",
  getParentRoute: () => ProtectedRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/$": typeof ProtectedSplatRoute
  "/chat": typeof ProtectedChatRoute
  "/dashboard": typeof ProtectedDashboardRoute
  "/auth/callback": typeof AuthCallbackRoute
  "/auth/forgot-password": typeof AuthForgotPasswordRoute
  "/auth/login": typeof AuthLoginRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/auth/signup": typeof AuthSignupRoute
  "/auth/verify-email": typeof AuthVerifyEmailRoute
  "/docs/$": typeof DocsSplatRoute
  "/oauth/consent": typeof OauthConsentRoute
  "/docs/": typeof DocsIndexRoute
  "/chat/$sessionId": typeof ProtectedChatSessionIdRoute
  "/discord/settings": typeof ProtectedDiscordSettingsRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/$": typeof ProtectedSplatRoute
  "/chat": typeof ProtectedChatRoute
  "/dashboard": typeof ProtectedDashboardRoute
  "/auth/callback": typeof AuthCallbackRoute
  "/auth/forgot-password": typeof AuthForgotPasswordRoute
  "/auth/login": typeof AuthLoginRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/auth/signup": typeof AuthSignupRoute
  "/auth/verify-email": typeof AuthVerifyEmailRoute
  "/docs/$": typeof DocsSplatRoute
  "/oauth/consent": typeof OauthConsentRoute
  "/docs": typeof DocsIndexRoute
  "/chat/$sessionId": typeof ProtectedChatSessionIdRoute
  "/discord/settings": typeof ProtectedDiscordSettingsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/_protected": typeof ProtectedRouteWithChildren
  "/_protected/$": typeof ProtectedSplatRoute
  "/_protected/chat": typeof ProtectedChatRoute
  "/_protected/dashboard": typeof ProtectedDashboardRoute
  "/auth/callback": typeof AuthCallbackRoute
  "/auth/forgot-password": typeof AuthForgotPasswordRoute
  "/auth/login": typeof AuthLoginRoute
  "/auth/reset-password": typeof AuthResetPasswordRoute
  "/auth/signup": typeof AuthSignupRoute
  "/auth/verify-email": typeof AuthVerifyEmailRoute
  "/docs/$": typeof DocsSplatRoute
  "/oauth/consent": typeof OauthConsentRoute
  "/docs/": typeof DocsIndexRoute
  "/_protected/chat_/$sessionId": typeof ProtectedChatSessionIdRoute
  "/_protected/discord/settings": typeof ProtectedDiscordSettingsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/$"
    | "/chat"
    | "/dashboard"
    | "/auth/callback"
    | "/auth/forgot-password"
    | "/auth/login"
    | "/auth/reset-password"
    | "/auth/signup"
    | "/auth/verify-email"
    | "/docs/$"
    | "/oauth/consent"
    | "/docs/"
    | "/chat/$sessionId"
    | "/discord/settings"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/$"
    | "/chat"
    | "/dashboard"
    | "/auth/callback"
    | "/auth/forgot-password"
    | "/auth/login"
    | "/auth/reset-password"
    | "/auth/signup"
    | "/auth/verify-email"
    | "/docs/$"
    | "/oauth/consent"
    | "/docs"
    | "/chat/$sessionId"
    | "/discord/settings"
  id:
    | "__root__"
    | "/"
    | "/_protected"
    | "/_protected/$"
    | "/_protected/chat"
    | "/_protected/dashboard"
    | "/auth/callback"
    | "/auth/forgot-password"
    | "/auth/login"
    | "/auth/reset-password"
    | "/auth/signup"
    | "/auth/verify-email"
    | "/docs/$"
    | "/oauth/consent"
    | "/docs/"
    | "/_protected/chat_/$sessionId"
    | "/_protected/discord/settings"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  AuthCallbackRoute: typeof AuthCallbackRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
  DocsSplatRoute: typeof DocsSplatRoute
  OauthConsentRoute: typeof OauthConsentRoute
  DocsIndexRoute: typeof DocsIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_protected": {
      id: "/_protected"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/docs/": {
      id: "/docs/"
      path: "/docs"
      fullPath: "/docs/"
      preLoaderRoute: typeof DocsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/oauth/consent": {
      id: "/oauth/consent"
      path: "/oauth/consent"
      fullPath: "/oauth/consent"
      preLoaderRoute: typeof OauthConsentRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/docs/$": {
      id: "/docs/$"
      path: "/docs/$"
      fullPath: "/docs/$"
      preLoaderRoute: typeof DocsSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/verify-email": {
      id: "/auth/verify-email"
      path: "/auth/verify-email"
      fullPath: "/auth/verify-email"
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/signup": {
      id: "/auth/signup"
      path: "/auth/signup"
      fullPath: "/auth/signup"
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/reset-password": {
      id: "/auth/reset-password"
      path: "/auth/reset-password"
      fullPath: "/auth/reset-password"
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/login": {
      id: "/auth/login"
      path: "/auth/login"
      fullPath: "/auth/login"
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/forgot-password": {
      id: "/auth/forgot-password"
      path: "/auth/forgot-password"
      fullPath: "/auth/forgot-password"
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/auth/callback": {
      id: "/auth/callback"
      path: "/auth/callback"
      fullPath: "/auth/callback"
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_protected/dashboard": {
      id: "/_protected/dashboard"
      path: "/dashboard"
      fullPath: "/dashboard"
      preLoaderRoute: typeof ProtectedDashboardRouteImport
      parentRoute: typeof ProtectedRoute
    }
    "/_protected/chat": {
      id: "/_protected/chat"
      path: "/chat"
      fullPath: "/chat"
      preLoaderRoute: typeof ProtectedChatRouteImport
      parentRoute: typeof ProtectedRoute
    }
    "/_protected/$": {
      id: "/_protected/$"
      path: "/$"
      fullPath: "/$"
      preLoaderRoute: typeof ProtectedSplatRouteImport
      parentRoute: typeof ProtectedRoute
    }
    "/_protected/discord/settings": {
      id: "/_protected/discord/settings"
      path: "/discord/settings"
      fullPath: "/discord/settings"
      preLoaderRoute: typeof ProtectedDiscordSettingsRouteImport
      parentRoute: typeof ProtectedRoute
    }
    "/_protected/chat_/$sessionId": {
      id: "/_protected/chat_/$sessionId"
      path: "/chat/$sessionId"
      fullPath: "/chat/$sessionId"
      preLoaderRoute: typeof ProtectedChatSessionIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
  }
}

interface ProtectedRouteChildren {
  ProtectedSplatRoute: typeof ProtectedSplatRoute
  ProtectedChatRoute: typeof ProtectedChatRoute
  ProtectedDashboardRoute: typeof ProtectedDashboardRoute
  ProtectedChatSessionIdRoute: typeof ProtectedChatSessionIdRoute
  ProtectedDiscordSettingsRoute: typeof ProtectedDiscordSettingsRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedSplatRoute: ProtectedSplatRoute,
  ProtectedChatRoute: ProtectedChatRoute,
  ProtectedDashboardRoute: ProtectedDashboardRoute,
  ProtectedChatSessionIdRoute: ProtectedChatSessionIdRoute,
  ProtectedDiscordSettingsRoute: ProtectedDiscordSettingsRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  AuthCallbackRoute: AuthCallbackRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
  DocsSplatRoute: DocsSplatRoute,
  OauthConsentRoute: OauthConsentRoute,
  DocsIndexRoute: DocsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
